import { FC } from 'react'
import styled from 'styled-components'
import { Text } from '@tuhi/components'
import { media } from '../../theme/breakpoints'

const Name = styled.span`
    font-size: 0.9em;
    display: inline-block;
    color: ${(p) => p.theme.colors.lightGrey};
    font-weight: bold;
`

const Time = styled(Name)``

const Column = styled.div<{ $alignment: 'left' | 'right' }>`
    display: flex;
    flex-direction: column;
    align-items: ${(p) => (p.$alignment === 'right' ? 'end' : 'start')};

    margin-left: ${(p) => (p.$alignment === 'right' ? 'auto' : '0')};

    ${Name} {
        margin-bottom: 4px;
    }

    ${Time} {
        margin-top: 4px;
    }

    ${Name}, ${Time} {
        margin-left: ${(p) => (p.$alignment === 'right' ? 'auto' : '0')};
    }
`

export const Bubble = styled.div<{
    $alignment: 'left' | 'right'
    $focus?: boolean
}>`
    max-width: 400px;
    padding: 16px 24px;
    width: fit-content;
    box-sizing: border-box;
    align-items: flex-start;

    color: ${(p) =>
        p.$alignment === 'right'
            ? p.theme.colors.white
            : p.theme.colors.tertiary.tertiary900};

    background-color: ${(p) =>
        p.$alignment === 'right'
            ? p.theme.colors.primary.green900
            : p.theme.colors.tertiary.tertiary50};

    border-radius: ${(p) =>
        p.$alignment === 'right' ? '24px 0 24px 24px' : '0 24px 24px 24px'};

    border: ${(p) =>
        p.$focus ? `4px solid ${p.theme.colors.primaryGreen}` : 'none'};

    ${media.mobile} {
        max-width: 100%;
    }
`

interface Props {
    speaker: string
    time: string
    text: string
    alignment: 'right' | 'left'
    index?: number
    active?: boolean
}

export const ChatBubble: FC<Props> = ({
    speaker,
    time,
    text,
    alignment,
    index,
    active,
}) => {
    return (
        <Column $alignment={alignment} id={`chat-bubble-${index}`}>
            <Text size={'xxSmall'} $weight={'medium'} color={'secondary'}>
                Speaker {speaker}
            </Text>
            <Bubble $focus={active} $alignment={alignment}>
                <Text size={'medium'} $weight={'regular'} color={'none'}>
                    {text}
                </Text>
            </Bubble>
            <Text size={'xxSmall'} $weight={'medium'} color={'secondary'}>
                {time}
            </Text>
        </Column>
    )
}
